import { render, staticRenderFns } from "./orderId.vue?vue&type=template&id=576189e8&scoped=true&"
import script from "./orderId.vue?vue&type=script&lang=js&"
export * from "./orderId.vue?vue&type=script&lang=js&"
import style0 from "./orderId.vue?vue&type=style&index=0&id=576189e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576189e8",
  null
  
)

export default component.exports